export default __webpack_public_path__ + "dda25c5886c5d267487b3d5c74768943.svg";